import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { DatePicker } from "@material-ui/pickers";
import { makeStyles, useTheme, withStyles } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import { useFormik } from "formik";
import {
  statusReportServiceId,
  STATUS_REPORT_DOCUMENT_STEP,
  VISA_TYPE_ID
} from "libs/configs/constant";
import { STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { readOCRPassport } from "redux/modules/passportSlice";
import {
  addPersonalStatusReport,
  addSmartFromStatusReport,
  getPartFormDetail,
  setStep
} from "redux/modules/statusReportSlice";
import { selectCurrentSmartForm } from "redux/modules/visaForm";
import FileService from "services/FileService";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    // display: "flex",
    // flexDirection: "column",
    // flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
  },
  wrapTitleContent: {
    width: 36,
    display: "flex",
    justifyContent: "center",
    marginRight: 3,
    marginLeft: 8,
  },
  badge: {
    display: "flex",
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: "#feb969",
    marginRight: 8,
    textAlign: "center",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  tableTitle: {
    color: "#8898aa",
    marginLeft: 16,
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  cellContent: {
    display: "flex",
  },
  cellContentWithRowSpan: {
    display: "flex",
    flex: 1,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: 120,
    width: 300,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  cellContentList: {
    paddingLeft: "45px",
    display: "flex",
    alignItems: "center",
  },
  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
  },
  wrapError: {
    textAlign: "right",
    fontSize: "0.8rem",
    color: "orangered",
    paddingRight: "10px",
  },
  middle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  linka: {
    textDecoration: "underline",
    cursor: "pointer",
    color: "mediumblue",
    paddingLeft: "15px",
  },
  closeButton: {
    color: "red",
    fontSize: "16px",
    paddingLeft: "10px",
    paddingTop: "5px",
    cursor: "pointer",
  },
}));

const StyleRadio = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Radio);

const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);

const Bagde = ({ number }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapTitleContent}>
      {!!number && <div className={classes.badge}>{number}</div>}
    </div>
  );
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
  },
  body: {
    fontSize: 16,
  },
}))(TableCell);

const TableRowHead = withStyles((theme) => ({
  root: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
  },
}))(TableRow);

function UploadButton({ id, onChange, title, disabled }) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          disabled={disabled}
          fullWidth={false}
          style={{ height: 40, width: 200 }}
          variant="outlined"
          color="primary"
          type="button"
        >
          {title || "BROWSE"}
        </ColorButton>
      </label>
    </div>
  );
}

export default function StatusReportA() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { smartDetail, partForm, oldData } = useSelector(
    (state) => state.statusReport
  );
  // const { personal, detail: oldDataDetail } = oldData;
  const personalDetail = useSelector((state) => state.personal.detail);
  const smartform = useSelector(selectCurrentSmartForm);
  const { showLoading, hideLoading } = useModalLoading();
  const theme = useTheme();
  const smartTypes = [
    VISA_TYPE_ID.SMART_T,
    VISA_TYPE_ID.SMART_E,
    VISA_TYPE_ID.SMART_O,
    VISA_TYPE_ID.SMART_I,
    VISA_TYPE_ID.SMART_S,
  ];

  const masterData = useSelector(selectMasterData);
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);
  const smartservice = get(masterData, "smartservice", []);
  const CountryConfig = get(masterData, "countryConfig", []);
  const applicantConfig = get(masterData, "applicantConfig", []);
  const relationshipConfig = get(masterData, "relationshipConfig", []);
  const [passportFile, setPassportFile] = useState(null);
  const passportState = useSelector((state) => state.passport);
  const [uploadPassportData, setUploadPassport] = useState(null);

  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get("draftId");

  const handleUploadContractTerm = async (event) => {
    showLoading();
    setPassportFile(event.target.files[0]);
    dispatch(readOCRPassport(event.target.files[0]));
    event.target.value = null;
  };

  const handleUploadForeignerShare = async (event) => {
    showLoading();

    const response = await FileService.uploadFile({
      file: event.target.files[0],
      FileID: null,
      Status: true,
    });
    const resData = response.results;
    var filename = resData.path.replace(/^.*[\\/]/, "");

    formik.setFieldValue(`partB.foreignerShareFileName`, filename);
    formik.setFieldValue(`partB.foreignerShareFile`, resData.fileID);

    hideLoading();
    event.target.value = null;
  };

  const getCompanies = () => {
    const companies = oldData?.detail.find(
      (x) => x?.smartName?.toLowerCase() === "companies"
    );

    if (companies) {
      const companiesdata = companies.value;
      return companiesdata;
    }
    return [];
  };

  const getDetailVal = (smartName, partName = null) => {
    let partFormId = null;

    if (partName != null && partForm?.defaultType) {
      const part = partForm.defaultType.find(
        (x) => x.partFromName === partName
      );
      partFormId = part ? part?.partfromId : null;
    }
    let controls = oldData?.detail.filter(
      (x) => x?.smartName?.toLowerCase() === smartName?.toLowerCase()
    );

    if (controls?.length > 1) {
      const control = controls.find((x) =>
        partFormId ? x.partfromId === partFormId : true
      );
      return control?.value || "";
    } else if (controls?.length === 1) {
      return controls?.length > 0 ? controls[0].value : "";
    }
  };

  const getItemDetail = (value, smartName, partName = null) => {
    let partFormId = null;

    if (partName != null && partForm?.defaultType) {
      const part = partForm.defaultType.find(
        (x) => x.partFromName === partName
      );
      partFormId = part ? part?.partfromId : null;
    }

    let controls = partForm.defaultType.filter(
      (x) => x.smartName.toLowerCase() === smartName.toLowerCase()
    );

    if (controls?.length > 1) {
      const control = controls.find((x) =>
        partFormId ? x.partfromId === partFormId : true
      );
      const body = {
        smartId: null,
        partfromId: control.partfromId,
        configsmartId: control.configsmartId,
        linkTable: control.linkTable,
        value: value,
      };

      return body;
    } else if (controls?.length === 1) {
      const body = {
        smartId: null,
        partfromId: controls[0].partfromId,
        configsmartId: controls[0].configsmartId,
        linkTable: controls[0].linkTable,
        value: value,
      };

      return body;
    }
  };

  const getItemsDetail = (values) => {
    const details = [];
    const partA = values.partA;
    const partB = values.partB;
    const partC = values.partC;
    const partD = values.partD;

    const email = getItemDetail(partA.email, "email");
    details.push(email);

    const phoneNumber = getItemDetail(partA.phoneNumber, "phoneNumber");
    details.push(phoneNumber);

    const addressInThai = getItemDetail(partA.addressInThai, "addressInThai");
    details.push(addressInThai);

    const smart = getItemDetail(partA.smart, "smart");
    details.push(smart);

    if (
      smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_T ||
      smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_E ||
      smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_S
    ) {
      // Get Data Part B

      if (partB.employerinthai) {
        const detail = getItemDetail(partB.employerinthai, "employerinthai");
        details.push(detail);
      }
      if (partB.jobposition) {
        const detail = getItemDetail(partB.jobposition, "jobposition");
        details.push(detail);
      }
      if (partB.jobsubposition) {
        const detail = getItemDetail(partB.jobsubposition, "jobsubposition");
        details.push(detail);
      }
      if (partB.companyaddress) {
        const detail = getItemDetail(partB.companyaddress, "companyaddress");
        details.push(detail);
      }
      if (partB.phoneNumber) {
        const detail = getItemDetail(
          partB.phoneNumber,
          "phoneNumber",
          "Part B"
        );
        details.push(detail);
      }
      if (partB.applicants) {
        const detail = getItemDetail(partB.applicants, "applicants");
        details.push(detail);
      }
      if (partB.specift) {
        const detail = getItemDetail(partB.specift, "specift");
        details.push(detail);
      }

      if (partB.thaiShare) {
        const detail = getItemDetail(partB.thaiShare, "thaiShare");
        details.push(detail);
      }

      if (partB.foreignerShare) {
        const detail = getItemDetail(partB.foreignerShare, "foreignerShare");
        details.push(detail);
      }
      if (partB.foreignerShareFile) {
        const detail = getItemDetail(
          partB.foreignerShareFile,
          "foreignerShareFile"
        );
        details.push(detail);
      }
    }

    if (smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_I) {
      // Get Data Part C
      const _companies = partC.companiesData.map((c) => {
        return {
          companiesId: null,
          companyName: c.companyName,
          valueofShares: c.valueofShares,
          amountOfConvertibledebt: c.AmountOfConvertibledebt,
          sameCompany: true,
          status: true,
        };
      });
      details.push(_companies);
    }

    if (smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_O) {
      // Get Data Part D
      if (partD.accompanyfistname) {
        const detail = getItemDetail(
          partD.accompanyfistname,
          "accompanyfistname"
        );
        details.push(detail);
      }
      if (partD.accompanymiddlename) {
        const detail = getItemDetail(
          partD.accompanymiddlename,
          "accompanymiddlename"
        );
        details.push(detail);
      }
      if (partD.accompanylastname) {
        const detail = getItemDetail(
          partD.accompanylastname,
          "accompanylastname"
        );
        details.push(detail);
      }
      if (partD.accompanytypesmartvisa) {
        const detail = getItemDetail(
          partD.accompanytypesmartvisa,
          "accompanytypesmartvisa"
        );
        details.push(detail);
      }
      if (partD.accompanyrelationship) {
        const detail = getItemDetail(
          partD.accompanyrelationship,
          "accompanyrelationship"
        );
        details.push(detail);
      }
      if (partD.workinginthailand) {
        const b = partD.workinginthailand ? 1 : 0;
        const detail = getItemDetail(b, "workinginthailand");

        detail.value = +detail.value;
        details.push(detail);
      }
      if (partD.information) {
        const detail = getItemDetail(partD.information, "information");
        details.push(detail);
      }
      if (partD.survey) {
        const detail = getItemDetail(partD.survey, "survey");
        details.push(detail);
      }
    }

    return details;
  };

  const validationSchema = yup.object({
    // partA: yup.object({
    //     firstName: yup.string().required("First name is a required field"),
    //     lastName: yup.string().required("Last name is a required field"),
    // })
  });

  console.log(getDetailVal("workinginthailand"));
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      partA: {
        firstname:
          passportState?.detail?.firstName || oldData?.personal?.firstname,
        middleName: oldData?.personal?.middleName,
        lastName:
          passportState?.detail?.lastName || oldData?.personal?.lastName,
        passportNumber: oldData?.personal?.passportNumber,
        dateofIssue: oldData?.personal?.dateofIssue,
        validuntil: oldData?.personal?.validuntil,
        phonenumber: getDetailVal("phonenumber", "Part A"),
        email: getDetailVal("email"),
        addressinthai: getDetailVal("addressinthai"),
      },
      partB: {
        employerinthai: getDetailVal("employerinthai"),
        jobposition: getDetailVal("jobposition"),
        jobsubposition: getDetailVal("jobsubposition"),
        companyaddress: getDetailVal("companyaddress"),
        phoneNumber: getDetailVal("phonenumber", "Part B"),
        applicants: getDetailVal("applicants"),
        specifit: getDetailVal("specift"),
        thaiShare: getDetailVal("thaiShare"),
        foreignerShare: getDetailVal("foreignerShare"),
        foreignerShareFile: getDetailVal("foreignerShareFile"),
        foreignerShareFileName: null,
      },
      partC: {
        companies: getDetailVal("companies"),
        companiesData: getCompanies(),
      },
      partD: {
        accompanyfistname: getDetailVal("accompanyfistname"),
        accompanymiddlename: getDetailVal("accompanymiddlename"),
        accompanylastname: getDetailVal("accompanylastname"),
        accompanytypesmartvisa: getDetailVal("accompanytypesmartvisa"),
        accompanyrelationship: getDetailVal("accompanyrelationship"),
        workinginthailand: getDetailVal("workinginthailand")?.toString(),
        information: getDetailVal("information"),
        survey: getDetailVal("survey"),
      },
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        showLoading();
        if (!draftId) {
          const details = getItemsDetail(values);
          const body = {
            draftId: null,
            smartserviceId: statusReportServiceId,
            personalId: personalDetail.personalID,
            smartserviceReferId: smartDetail.smartserviceId,
            survey: null,
            visaissuance: null,
            fileDocument: [],
            detail: details,
          };

          const bodyPersonal = {
            personalID: personalDetail.personalID,
            fistName: formik.values.partA.firstname,
            middleName: formik.values.partA.middleName,
            lastName: formik.values.partA.lastName,
            nationalityID: personalDetail.nationalityID,
            birthDate: personalDetail.birthDate,
            email: formik.values.partA.email,
            placeOfBirth: personalDetail.placeOfBirth,
            gender: personalDetail.gender,
            passportNumber: formik.values.partA.phonenumber,
            dateofIssue: formik.values.partA.dateofIssue,
            validuntil: formik.values.partA.validuntil,
            visatypeID: personalDetail.visatypeID,
          };

          const resPersonal = dispatch(addPersonalStatusReport(bodyPersonal));
          const res = await dispatch(addSmartFromStatusReport(body));
          const newDraftId = res.payload;
          await dispatch(
            getPartFormDetail({
              personalId: personalDetail.personalID,
              draftId: newDraftId,
            })
          );
        } else {
          await dispatch(
            getPartFormDetail({
              personalId: personalDetail.personalID,
              draftId: draftId,
            })
          );
        }
        window.scrollTo(0, 0);
        dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_B));
        hideLoading();
      } catch (error) {
        console.error(error);
        hideLoading();
      }
    },
  });

  const jobSubPositionConfig =
    jobPositionConfig.find(
      (job) => job.jobID === formik.values.partB.jobposition
    )?.jobSubPosition || [];

  const smartServiceFilter =
    smartservice.filter((ser) => smartTypes.indexOf(ser.smartserviceId) > -1) ||
    [];

  const CompaniesData = get(formik.values, "partC.companiesData", []);

  const canDisplay = (controlName, partName = null) => {
    if (partForm?.defaultType) {
      const allControls = partForm.defaultType.find((x) =>
        x.smartName.toLowerCase() === controlName.toLowerCase() &&
        partName != null
          ? x.partFromName === partName
          : true
      );
      return allControls && allControls.isShow;
    }
    return false;
  };

  const isError = (fieldName) =>
    get(formik.touched, fieldName, "") &&
    Boolean(get(formik.errors, fieldName, ""));

  const getErrorMessage = (fieldName) =>
    get(formik.touched, fieldName, "")
      ? get(formik.errors, fieldName, "") || " "
      : " ";

  const viewFile = async (fileId, fileName) => {
    openFileById(fileId);
  };

  useEffect(() => {
    dispatch(
      getMasterData({
        JobPositionConfig: true,
        smartservice: true,
        CountryConfig: true,
        ApplicantConfig: true,
        RelationshipConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (passportState) {
      if (passportState.isSuccess || passportState.isFailure) {
        hideLoading();
        setUploadPassport(passportFile);
      }
    }
  }, [passportState, hideLoading, passportFile]);

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <ContentTitle
          subTitle="Smart Visa Status Report"
          title="Status Report Request Form"
        />
        <Steper
          isStatusReport
          currentStep={0}
          stepInfo={STATUS_REPORT_DOCUMENT_STEP}
        />
        <form onSubmit={formik.handleSubmit}>
          <TableContainer
            name="partA"
            style={{ marginTop: 35, borderRadius: 4 }}
          >
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={6}>
                    <div className={classes.middle}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Part A : Personal Information
                      </Typography>
                      <UploadButton
                        onChange={handleUploadContractTerm}
                        disabled={draftId}
                        title="Update Passport"
                      />
                    </div>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCell colSpan={6}>
                    <div className={classes.cellContent}>
                      <Bagde number={1} />
                      <div>
                        <Typography>
                          Full English name as in passport
                        </Typography>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={0} />
                      <div className={classes.wrapField}>
                        <InputLabel>First name</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          disabled={draftId}
                          name="partA.firstname"
                          value={formik.values.partA.firstname}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("partA.firstname")}
                          helperText={getErrorMessage("partA.firstname")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>

                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Middle name</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          name="partA.middleName"
                          disabled={draftId}
                          value={formik.values.partA.middleName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("partA.middleName")}
                          helperText={getErrorMessage("partA.middleName")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Last name</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          name="partA.lastName"
                          value={formik.values.partA.lastName}
                          onChange={formik.handleChange}
                          disabled={draftId}
                          onBlur={formik.handleBlur}
                          error={isError("partA.lastName")}
                          helperText={getErrorMessage("partA.lastName")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={2} />
                      <div className={classes.wrapField}>
                        <InputLabel>Passport number</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          name="partA.passportNumber"
                          disabled={draftId}
                          value={formik.values.partA.passportNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("partA.passportNumber")}
                          helperText={getErrorMessage("partA.passportNumber")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={3} />
                      <div className={classes.wrapField}>
                        <InputLabel>Date of issue ( dd-mm-yyyy )</InputLabel>
                        <DatePicker
                          // style={{ width: 200 }}
                          className={classes.formControl}
                          inputVariant="outlined"
                          disableFuture={false}
                          openTo="year"
                          format="DD-MM-YYYY"
                          disabled={draftId}
                          label="Date of issue"
                          views={["year", "month", "date"]}
                          name={`partA.dateofIssue`}
                          value={
                            get(formik.values, `partA.dateofIssue`, null) ||
                            null
                          }
                          onChange={(date) => {
                            formik.setFieldValue(
                              `partA.dateofIssue`,
                              date.format("YYYY-MM-DD")
                            );
                          }}
                          error={isError(`partA.dateofIssue`)}
                          helperText={getErrorMessage(`partA.dateofIssue`)}
                        />
                      </div>
                    </div>
                  </StyledTableCell>

                  {canDisplay("validuntil") && (
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <Bagde number={4} />
                        <div className={classes.wrapField}>
                          <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
                          <DatePicker
                            className={classes.formControl}
                            // style={{ width: 200 }}
                            inputVariant="outlined"
                            disableFuture={false}
                            openTo="year"
                            disabled={draftId}
                            format="DD-MM-YYYY"
                            label="Valid until"
                            views={["year", "month", "date"]}
                            name={`partA.validuntil`}
                            value={
                              get(formik.values, `partA.validuntil`, null) ||
                              null
                            }
                            onChange={(date) => {
                              formik.setFieldValue(
                                `partA.validuntil`,
                                date.format("YYYY-MM-DD")
                              );
                            }}
                            error={isError(`partA.validuntil`)}
                            helperText={getErrorMessage(`partA.validuntil`)}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  )}
                </TableRow>

                <TableRow>
                  {canDisplay("phonenumber", "Part A") && (
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <Bagde number={5} />
                        <div className={classes.wrapField}>
                          <InputLabel>Home / mobile phone number</InputLabel>
                          <TextField
                            variant="outlined"
                            disabled={draftId}
                            className={classes.textField}
                            name="partA.phonenumber"
                            inputProps={{ maxLength: 10 }}
                            onKeyDown={(e) => {
                              const pattern = /[^0-9]/g;
                              const isNotAllow =
                                e.key.length === 1 && pattern.test(e.key);

                              if (isNotAllow) {
                                e.preventDefault();
                              }
                            }}
                            value={formik.values.partA.phonenumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("partA.phonenumber")}
                            helperText={getErrorMessage("partA.phonenumber")}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  )}
                  {canDisplay("email") && (
                    <StyledTableCell colSpan={3}>
                      <div className={classes.cellContent}>
                        <Bagde number={6} />
                        <div className={classes.wrapField}>
                          <InputLabel>E-mail address</InputLabel>
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            name="partA.email"
                            disabled={draftId}
                            value={formik.values.partA.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("partA.email")}
                            helperText={getErrorMessage("partA.email")}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  )}
                </TableRow>

                <TableRow>
                  {canDisplay("addressinthai") && (
                    <StyledTableCell colSpan={6}>
                      <div className={classes.cellContent}>
                        <Bagde number={7} />
                        <div className={classes.wrapField}>
                          <InputLabel>Current address in Thailand</InputLabel>
                          <TextField
                            disabled={draftId}
                            variant="outlined"
                            className={classes.textField}
                            name="partA.addressinthai"
                            multiline
                            rows={3}
                            value={formik.values.partA.addressinthai}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError("partA.addressinthai")}
                            helperText={getErrorMessage("partA.addressinthai")}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {(smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_T ||
            smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_E ||
            smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_S) && (
            <TableContainer
              name="partB"
              style={{ marginTop: 35, borderRadius: 4, overflow: "hidden" }}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Part B : Data of the employer or sponsor in Thailand
                      </Typography>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {canDisplay("employerinthai") && (
                      <StyledTableCell colSpan={4}>
                        <div className={classes.cellContent}>
                          <div className={classes.flexRow}>
                            <Bagde number={1} />
                            <InputLabel>Company Name</InputLabel>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ marginLeft: 16 }}
                            >
                              <TextField
                                variant="outlined"
                                className={classes.textField}
                                disabled={draftId}
                                name="partB.employerinthai"
                                value={formik.values.partB.employerinthai}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={isError("partB.employerinthai")}
                                helperText={getErrorMessage(
                                  "partB.employerinthai"
                                )}
                              />
                            </FormControl>
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                  </TableRow>

                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <div className={classes.cellContent}>
                        <div className={classes.flexRow}>
                          <Bagde number={2} />
                          <InputLabel>Job position</InputLabel>
                          {canDisplay("jobposition") && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ marginLeft: 16 }}
                            >
                              <InputLabel>Selected Job position</InputLabel>
                              <Select
                                disabled={draftId}
                                label="Selected Job position"
                                name="partB.jobposition"
                                value={formik.values.partB.jobposition}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                {jobPositionConfig.map((jobPosition) => (
                                  <MenuItem
                                    key={jobPosition.jobID}
                                    value={jobPosition.jobID}
                                  >
                                    {jobPosition.jobName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                          {canDisplay("jobsubposition") && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ marginLeft: 16 }}
                            >
                              <InputLabel>Selected Job Sub position</InputLabel>
                              <Select
                                disabled={draftId}
                                label="Selected Job Sub position"
                                name="partB.jobsubposition"
                                value={formik.values.partB.jobsubposition}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                {jobSubPositionConfig.map((jobPosition) => (
                                  <MenuItem
                                    key={jobPosition.jobsubID}
                                    value={jobPosition.jobsubID}
                                  >
                                    {jobPosition.jobsubName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    {canDisplay("companyaddress") && (
                      <StyledTableCell colSpan={3}>
                        <div className={classes.cellContent}>
                          <Bagde number={3} />
                          <div className={classes.wrapField}>
                            <InputLabel>Work address</InputLabel>
                            <TextField
                              disabled={draftId}
                              variant="outlined"
                              className={classes.textField}
                              name="partB.companyaddress"
                              value={formik.values.partB.companyaddress}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError("partB.companyaddress")}
                              helperText={getErrorMessage(
                                "partB.companyaddress"
                              )}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                    {canDisplay("phonenumber", "Part B") && (
                      <StyledTableCell colSpan={5}>
                        <div className={classes.cellContent}>
                          <Bagde number={4} />
                          <div className={classes.wrapField}>
                            <InputLabel>Work phone</InputLabel>
                            <TextField
                              disabled={draftId}
                              variant="outlined"
                              className={classes.textField}
                              name="partB.phoneNumber"
                              value={formik.values.partB.phoneNumber}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError("partB.phoneNumber")}
                              helperText={getErrorMessage("partB.phoneNumber")}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <div className={classes.cellContent}>
                        <Bagde number={5} />
                        <div className={classes.wrapField}>
                          <InputLabel>
                            The applicant’s involvement in the company
                          </InputLabel>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <div className={classes.cellContent}>
                        {canDisplay(`applicants`) && (
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: 430 }}
                          >
                            <InputLabel>
                              Selected The applicant’s involvement in the
                              company
                            </InputLabel>
                            <Select
                              disabled={draftId}
                              label="Selected The applicant’s involvement in the company "
                              name="partB.applicants"
                              value={formik.values.partB.applicants}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              {applicantConfig.map((applicant) => (
                                <MenuItem
                                  key={applicant.applicantID}
                                  value={applicant.applicantID}
                                >
                                  {applicant.applicantName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                        {canDisplay(`specift`) &&
                          formik.values.partB.applicants === "O" && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <TextField
                                disabled={draftId}
                                placeholder="Specify"
                                style={{ marginTop: 0 }}
                                variant="outlined"
                                className={classes.textField}
                                name="partB.specifit"
                                value={formik.values.partB.specifit}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={isError("partB.specifit")}
                                helperText={getErrorMessage("partB.specifit")}
                              />
                            </FormControl>
                          )}

                        {canDisplay(`thaiShare`) &&
                          formik.values.partB.applicants === "S" && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ width: 180 }}
                            >
                              <TextField
                                disabled={draftId}
                                placeholder="Thai % Share"
                                style={{ marginTop: 0 }}
                                variant="outlined"
                                type="number"
                                className={classes.textField}
                                name="partB.thaiShare"
                                value={formik.values.partB.thaiShare}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={isError("partB.thaiShare")}
                                helperText={getErrorMessage("partB.thaiShare")}
                              />
                            </FormControl>
                          )}
                        {canDisplay(`foreignerShare`) &&
                          formik.values.partB.applicants === "S" && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ width: 180 }}
                            >
                              <TextField
                                placeholder="Foreigner % Share"
                                style={{ marginTop: 0 }}
                                variant="outlined"
                                type="number"
                                disabled={draftId}
                                className={classes.textField}
                                name="partB.foreignerShare"
                                value={formik.values.partB.foreignerShare}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={isError("partB.foreignerShare")}
                                helperText={getErrorMessage(
                                  "partB.foreignerShare"
                                )}
                              />
                            </FormControl>
                          )}
                      </div>
                      {canDisplay(`foreignerShareFile`) &&
                        formik.values.partB.applicants === "S" && (
                          <div className={classes.cellContent}>
                            <div className={classes.flexRow}>
                              <InputLabel style={{ paddingRight: 15 }}>
                                Foreign Business License
                              </InputLabel>
                              {!draftId && (
                                <UploadButton
                                  onChange={handleUploadForeignerShare}
                                  title="Upload"
                                  id="upload-fbl"
                                  disabled={draftId}
                                />
                              )}

                              {draftId &&
                                formik.values.partB.foreignerShareFile && (
                                  <ColorButton
                                    component="span"
                                    fullWidth={false}
                                    style={{ height: 40, width: 200 }}
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    onClick={() => {
                                      openFileById(
                                        formik.values.partB.foreignerShareFile
                                      );
                                    }}
                                  >
                                    View File
                                  </ColorButton>
                                )}
                              {formik.values.partB.foreignerShareFile && (
                                <>
                                  <label
                                    className={classes.linka}
                                    onClick={() => {
                                      viewFile(
                                        formik.values.partB.foreignerShareFile,
                                        formik.values.partB
                                          .foreignerShareFileName
                                      );
                                    }}
                                  >
                                    {formik.values.partB.foreignerShareFileName}
                                  </label>

                                  {!draftId && (
                                    <CloseIcon
                                      className={classes.closeButton}
                                      onClick={() => {
                                        formik.setFieldValue(
                                          `partB.foreignerShareFileName`,
                                          null
                                        );
                                        formik.setFieldValue(
                                          `partB.foreignerShareFile`,
                                          null
                                        );
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
          {canDisplay(`companies`) &&
            smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_I && (
              <TableContainer
                name="partC"
                style={{ marginTop: 35, borderRadius: 4 }}
              >
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell colSpan={6}>
                        <Typography variant="h6" className={classes.tableTitle}>
                          Part C: Investment in Thailand
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <StyledTableCell colSpan={6}>
                        <div className={classes.cellContent}>
                          <Bagde number={1} />
                          <div>
                            <Typography>
                              List of companies in which the applicant has invested in
                            </Typography>
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell align="center">
                        <InputLabel>Company Name</InputLabel>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <InputLabel>Value of shares (Baht)</InputLabel>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <InputLabel>
                          Amount of convertible debt (Baht)
                        </InputLabel>
                      </StyledTableCell>
                      <StyledTableCell align="center"></StyledTableCell>
                    </TableRow>

                    {CompaniesData.map((com, index) => (
                      <TableRow
                        key={index}
                        style={com.status ? {} : { display: "none" }}
                      >
                        <StyledTableCell align="center">
                          <TextField
                            disabled={draftId}
                            variant="outlined"
                            className={classes.textField}
                            placeholder=""
                            name={`partC.companiesData.${index}.companyName`}
                            value={get(
                              formik.values,
                              `partC.companiesData.${index}.companyName`,
                              ""
                            )}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `partC.companiesData.${index}.companyName`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `partC.companiesData.${index}.companyName`,
                              formik
                            )}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <TextField
                            disabled={draftId}
                            variant="outlined"
                            className={classes.textField}
                            placeholder=""
                            name={`partC.companiesData.${index}.valueofShares`}
                            type="number"
                            value={get(
                              formik.values,
                              `partC.companiesData.${index}.valueofShares`,
                              ""
                            )}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `partC.companiesData.${index}.valueofShares`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `partC.companiesData.${index}.valueofShares`,
                              formik
                            )}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <TextField
                            disabled={draftId}
                            variant="outlined"
                            className={classes.textField}
                            placeholder=""
                            type="number"
                            name={`partC.companiesData.${index}.amountOfConvertibledebt`}
                            value={get(
                              formik.values,
                              `partC.companiesData.${index}.amountOfConvertibledebt`,
                              ""
                            )}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `partC.companiesData.${index}.amountOfConvertibledebt`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `partC.companiesData.${index}.amountOfConvertibledebt`,
                              formik
                            )}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {!draftId && (
                            <IconButton
                              style={{
                                width: 40,
                                color: theme.palette.error.main,
                              }}
                              size="small"
                              onClick={async () => {
                                if (
                                  get(
                                    formik.values,
                                    `partC.companiesData.${index}.companiesId`,
                                    ""
                                  )
                                ) {
                                  formik.setFieldValue(
                                    `partC.companiesData[${index}].status`,
                                    false
                                  );
                                } else {
                                  formik.setFieldValue(
                                    "partC.companiesData",
                                    CompaniesData.filter((__, i) => i !== index)
                                  );
                                }
                              }}
                            >
                              <DeleteForeverIcon />
                            </IconButton>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    ))}

                    <TableRow>
                      <StyledTableCell colSpan={4}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {!draftId && (
                            <AddRowButton
                              onClick={() => {
                                formik.setFieldValue("partC.companiesData", [
                                  ...CompaniesData,
                                  {
                                    companiesId: null,
                                    companyName: "",
                                    valueofShares: "",
                                    amountOfConvertibledebt: "",
                                    sameCompany: true,
                                    status: true,
                                  },
                                ]);
                              }}
                            />
                          )}
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}

          {smartDetail?.smartserviceId === VISA_TYPE_ID.SMART_O && (
            <TableContainer
              name="partD"
              style={{ marginTop: 35, borderRadius: 4 }}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Part D: Smart O
                      </Typography>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <StyledTableCell colSpan={6}>
                      <div className={classes.cellContent}>
                        <Bagde number={1} />
                        <div>
                          <Typography>
                            Please specify the name of Smart Visa holder whom
                            you accompany
                          </Typography>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    {canDisplay(`accompanyfistname`) && (
                      <StyledTableCell colSpan={2}>
                        <div className={classes.cellContent}>
                          <Bagde number={0} />
                          <div className={classes.wrapField}>
                            <InputLabel>First name</InputLabel>
                            <TextField
                              disabled={draftId}
                              variant="outlined"
                              className={classes.textField}
                              name="partD.accompanyfistname"
                              value={formik.values.partD.accompanyfistname}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError("partD.accompanyfistname")}
                              helperText={getErrorMessage(
                                "partD.accompanyfistname"
                              )}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                    {canDisplay(`accompanymiddlename`) && (
                      <StyledTableCell colSpan={2}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <InputLabel>Middle name</InputLabel>
                            <TextField
                              disabled={draftId}
                              variant="outlined"
                              className={classes.textField}
                              name="partD.accompanymiddlename"
                              value={formik.values.partD.accompanymiddlename}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError("partD.accompanymiddlename")}
                              helperText={getErrorMessage(
                                "partD.accompanymiddlename"
                              )}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                    {canDisplay(`accompanylastname`) && (
                      <StyledTableCell colSpan={2}>
                        <div className={classes.cellContent}>
                          <div className={classes.wrapField}>
                            <InputLabel>Last name</InputLabel>
                            <TextField
                              disabled={draftId}
                              variant="outlined"
                              className={classes.textField}
                              name="partD.accompanylastname"
                              value={formik.values.partD.accompanylastname}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError("partD.accompanylastname")}
                              helperText={getErrorMessage(
                                "partD.accompanylastname"
                              )}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                  </TableRow>

                  <TableRow>
                    {canDisplay(`accompanytypesmartvisa`) && (
                      <StyledTableCell colSpan={2}>
                        <div className={classes.cellContent}>
                          <Bagde number={2} />
                          <div className={classes.wrapField}>
                            <InputLabel>Type of his/her Smart Visa</InputLabel>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <InputLabel>
                                Selected Type of his/her Smart Visa
                              </InputLabel>
                              <Select
                                disabled={draftId}
                                label="Selected Type of his/her Smart Visa"
                                name="partD.accompanytypesmartvisa"
                                value={
                                  formik.values.partD.accompanytypesmartvisa
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                {smartServiceFilter.map((service) => (
                                  <MenuItem
                                    key={service.smartserviceId}
                                    value={service.smartserviceId}
                                  >
                                    {service.smartserviceName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                    {canDisplay(`accompanyrelationship`) && (
                      <StyledTableCell
                        colSpan={4}
                        style={{ verticalAlign: "top" }}
                      >
                        <div className={classes.cellContent}>
                          <Bagde number={3} />
                          <div className={classes.wrapField}>
                            <InputLabel>
                              Relationship with the main Smart Visa
                              holder/applicant
                            </InputLabel>

                            <FormControl
                              component="fieldset"
                              className={classes.textField}
                            >
                              <RadioGroup
                                disabled={draftId}
                                row
                                name="partD.accompanyrelationship"
                                value={
                                  formik.values.partD.accompanyrelationship
                                }
                                onChange={formik.handleChange}
                              >
                                {relationshipConfig.map((r) => (
                                  <FormControlLabel
                                    disabled={draftId}
                                    key={r.relationshipID}
                                    value={r.relationshipID}
                                    control={<StyleRadio />}
                                    label={r.relationshipName}
                                  />
                                ))}
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </StyledTableCell>
                    )}
                  </TableRow>

                  {canDisplay(`workinginthailand`) && (
                    <TableRow>
                      <StyledTableCell colSpan={6}>
                        <div className={classes.cellContent}>
                          <Bagde number={3} />
                          <div className={classes.wrapField}>
                            <InputLabel>
                              {" "}
                              Are you working in Thailand?{" "}
                            </InputLabel>
                            <FormControl
                              component="fieldset"
                              className={classes.textField}
                            >
                              <RadioGroup
                                row
                                disabled={draftId}
                                name="partD.workinginthailand"
                                value={formik.values.partD.workinginthailand}
                                onChange={formik.handleChange}
                              >
                                <FormControlLabel
                                  value={"1"}
                                  control={<StyleRadio />}
                                  label="Yes"
                                  disabled={draftId}
                                />
                                <FormControlLabel
                                  value={"0"}
                                  control={<StyleRadio />}
                                  label="No"
                                  disabled={draftId}
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {canDisplay(`information`) && (
                    <TableRow>
                      <StyledTableCell colSpan={6}>
                        <div className={classes.cellContent}>
                          <Bagde number={4} />
                          <div className={classes.wrapField}>
                            <InputLabel>
                              If your answer is YES, please provide the
                              information on your job title/ Company name/
                              Address
                            </InputLabel>
                            <TextField
                              variant="outlined"
                              className={classes.textField}
                              name="partD.information"
                              value={formik.values.partD.information}
                              onChange={formik.handleChange}
                              multiline
                              rows={3}
                              disabled={
                                !formik.values.partD.workinginthailand ===
                                  "1" || draftId
                              }
                              onBlur={formik.handleBlur}
                              error={isError("partD.information")}
                              helperText={getErrorMessage("partD.information")}
                            />
                          </div>
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {/* {canDisplay(`survey`) && (
                    <>
                      <TableRow>
                        <StyledTableCell colSpan={6}>
                          <div className={classes.cellContent}>
                            <Bagde number={5} />
                            <div>
                              <Typography>Survey</Typography>
                            </div>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell colSpan={6}>
                          <div className={classes.cellContent}>
                            <div className={classes.wrapField}>
                              <InputLabel>
                                Please describe an activity you have been
                                engaged in that resulted in technology
                                transfer/contribution to development of science
                                and technology in Thailand?
                              </InputLabel>
                              <TextField
                                disabled={draftId}
                                variant="outlined"
                                className={classes.textField}
                                name="partD.survey"
                                value={formik.values.partD.survey}
                                onChange={formik.handleChange}
                                multiline
                                rows={3}
                                onBlur={formik.handleBlur}
                                error={isError("partD.survey")}
                                helperText={getErrorMessage("partD.survey")}
                              />
                            </div>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    </>
                  )} */}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <div
            style={{
              marginTop: 44,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="primary"
              type="submit"
            >
              Next
            </ColorButton>
          </div>
        </form>
      </div>
    </Paper>
  );
}
